import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode, ParseResult } from '../FormatterTypes';
import { IInternalDateFormat } from '../Displayers/TEDCustomDateTimeDisplayer';
import { encodeDate } from '../Utils/TimeDateUtils';

// Fungerar inte korrekt i alla fall. Behöver korrigering om den börjar användas.
export class TEDParseDateTimeStr extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseDateTimeStr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseDateTimeStr;

  public mode() {
    return TEDParseDateTimeMode.pdmDateTimeString;
  }

  makeDateTime(dateParts: IInternalDateFormat): {
    result: ParseResult;
    value: string | null;
  } {
    const dateResult: { result: ParseResult; value: any } = {
      result: ParseResult.ERROR,
      value: null,
    };
    // const allowZero =
    //   formatterBoolParamDef('AllowZero', params, defaultParams);
    if (
      (dateParts.ty === 0 || dateParts.tm === 0 || dateParts.td === 0) &&
      (dateParts.th >= 0 ||
        dateParts.tn >= 0 ||
        dateParts.ts >= 0 ||
        dateParts.tms >= 0 ||
        false)
    ) {
      dateResult.result = ParseResult.ERROR_PATTERN;
    }
    const date = encodeDate(dateParts);
    if (date) {
      dateResult.result = ParseResult.OK;
      dateResult.value = date.toLocaleDateString('sv-SE');
    }

    return dateResult;
  }
}
